<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small class="font-size:15px; font-weight: bold">manage employees</small>
      </legend>
      <div></div>
      <div>
        <div class="employeesLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>
          loading employees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemEmployees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all'
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Edit'">
              <button class="btn btn-info btn-sm btn-block" @click="viewEmployee(props.row.id)">
                <i class="fa fa-edit"></i> Edit employee
              </button>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
           
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Employee no",
          field: "employee_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter emp number"
          }
        },
        {
          label: "Employee name",
          field: "employee_name",
          type: "text",
        },
        {
          label: "Id no",
          field: "id_no",
          type: "text",
        },
        {
          label: "Phone no",
          field: "phone_no",
          type: "text",
        },
        {
          label: "Edit",
          field: "Edit",
          width: "40px",
          html: true
        },
      ]
    };
  },
  created() {
    this.loadEmployees();
  },
  computed: {
    ...mapGetters(["systemEmployees"])
  },
  methods: {
    ...mapActions([
      "loadEmployees",
      "viewEmployee",
      "leaveApplication",
      "advanceApllication",
      "checkIn"
    ])
  }
};
</script>
<style scoped>
.creatingAttendanceLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/employees/manageemployees.vue